import { z } from 'zod';

const icd10CodeSchema = z.object({
  code: z.string().trim().min(1),
  description: z.string().trim().min(1),
});

export const draftExistingLabToolInputSchema = z.object({
  labTestId: z.string().trim().min(1, 'Lab test ID is required'),
  labTestName: z.string().trim().min(1, 'Lab test name is required'),
  notes: z.string().optional(),
  priority: z.boolean().optional(),
  icdCodes: z.array(icd10CodeSchema).min(1, 'At least one ICD-10 diagnosis code is required'),
});

export type DraftExistingLabToolInput = z.infer<typeof draftExistingLabToolInputSchema>;

export type DraftExistingLabFromToolInputResult =
  | { ok: true; draft: DraftExistingLabToolInput }
  | { ok: false };

export function draftExistingLabFromToolInput(input: unknown): DraftExistingLabFromToolInputResult {
  const parsed = draftExistingLabToolInputSchema.safeParse(input);
  if (!parsed.success) {
    console.error('[draft_existing_lab] Tool call input validation failed', {
      errors: parsed.error.format(),
      input,
    });
    return { ok: false };
  }
  return { ok: true, draft: parsed.data };
}
